import * as React from 'react';
import Button from '@mui/material/Button';
import { DamsColors } from '../styles/DamsColors';
import { CircularProgress, Typography } from '@mui/material';
import { DamsAppAsset } from '../../assets/registry';

interface AuthBtnProps {
    title?: string,
    size?: 'small' | 'medium' | 'large' | string,
    showIcon?: boolean,
    onPress?: () => void,
    loading?: boolean,
}

export default function AuthButton({
    title = 'Auth',
    size = '',
    showIcon = true,
    onPress,
    loading = false,
}: Readonly<AuthBtnProps>) {


    const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        if (onPress !== undefined) {
            onPress();
        }
    }

    return (
        <Button
            variant="contained"
            sx={{ ...styles.buttonContainer, width: getButtonWidth(size), ...(loading && styles.loadingButton) }}
            onClick={handleOnClick}
            endIcon={
                !loading && showIcon && (
                    <img
                        src={DamsAppAsset.icons.white_forward_arrow}
                        alt='arrow icon'
                        style={styles.arrowIcon} />
                )
            }
            // disabled={loading}
        >
            {loading ? (
                <CircularProgress size={20} sx={styles.spinner} />
            ) : (
                <Typography
                    fontFamily={'Inter'}
                    fontSize={'14px'}
                    fontWeight={600}
                    color={'white'}
                    textTransform={'none'}
                    textAlign={'center'}
                >
                    {title}
                </Typography>
            )}

        </Button>
    );
}

const getButtonWidth = (size?: 'small' | 'medium' | 'large' | string) => {
    switch (size) {
        case 'small':
            return 100;
        case 'medium':
            return 145;
        case 'large':
            return 271;
        default:
            return 70;
    }
};

const styles = {
    buttonContainer: {
        backgroundColor: DamsColors.Authentication.Button,
        borderRadius: '8px',
        height: 40,

        '&:hover': {
            backgroundColor: DamsColors.Authentication.Button,
        }
    },
    arrowIcon: {
        color: 'white',
        width: 15,
        Height: 13,

    },

    spinner: {
        color: 'white',
    },

    loadingButton: {
        backgroundColor: DamsColors.Authentication.Button, 
        opacity: 1,
    }
}
